import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const LoadingContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
`;

const LoadingOverlay = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: ${props => (props.visible ? "100%" : "0")};
  height: ${props => (props.visible ? "100%" : "0")};
  background-color: ${props => props.theme.overlay};
  z-index: 99;
`;

const LoadingImage = styled.img`
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  z-index: 99;
`;

class LoadingIndicator extends PureComponent {
  render() {
    return this.props.visible ? (
      <LoadingContainer>
        <LoadingOverlay visible={this.props.overlay} />
        <LoadingImage src={this.props.image} />
      </LoadingContainer>
    ) : (
      <div />
    );
  }
}

LoadingIndicator.defaultProps = {
  visible: false,
  image: "images/loadingSpinner.svg",
  overlay: true
};

LoadingIndicator.propTypes = {
  visible: PropTypes.bool,
  image: PropTypes.string,
  overlay: PropTypes.bool
};

export default LoadingIndicator;



// WEBPACK FOOTER //
// ./app/components/LoadingIndicator.js